<template>
  <div class="col-3-center">
    <!-- <h2>Downloads</h2> -->
    <ul>
      <li v-for="(item, i) in items" :key="i">
        <span style="background:#b3db11; text-transform: uppercase">{{item.title}}</span>
        <ul>
          <li v-for="(link, j) in item.links" :key="j">
            <a :href="link.src" target="_blank">{{link.title}}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: "09/18 - 06/19",
          links: [
            {
              title: "Leitsätze Etappe 1",
              src: "/static/dokumente/leitsätze_etappe1.pdf"
            },
            {
              title: "Kunst und Landschaft",
              src: "/static/dokumente/kunst_landschaft.pdf"
            },
            {
              title: "BEVÖLKERUNGSENTWICKLUNG",
              src:
                "/static/dokumente/Steckbrief_01_Bevoelkerungsentwicklung.pdf"
            },
            {
              title: "EINZELHANDELSENTWICKLUNG",
              src:
                "/static/dokumente/Steckbrief_02_Einzelhandelsentwicklung.pdf"
            },
            {
              title: "ENERGIEVERSORGUNG",
              src: "/static/dokumente/Steckbrief_03_Energie.pdf"
            },
            {
              title: "GEWÄSSERENTWICKLUNG",
              src: "/static/dokumente/Steckbrief_04_Gewaesserentwicklung.pdf"
            },
            {
              title: "GEWERBEFLÄCHEN",
              src: "/static/dokumente/Steckbrief_05_Gewerbeflaechen.pdf"
            },
            {
              title: "SPORT & FREIZEIT",
              src: "/static/dokumente/Steckbrief_06_Sport_und_Freizeit.pdf"
            },
            {
              title: "VERKEHRSENTWICKLUNGSPLAN",
              src: "/static/dokumente/Steckbrief_07_Verkehr.pdf"
            },
            {
              title: "Pressemitteilung 1",
              src: "/static/dokumente/pressemitteilung_1.pdf"
            },
            {
              title: "Pressemitteilung 2",
              src: "/static/dokumente/pressemitteilung_2.pdf"
            }
          ]
        },
        {
          title: "07/19 - 11/19",
          links: [
            {
              title: "Pressemitteilung 3 - Allgemeines",
              src: "/static/dokumente/pressemitteilung_3_allgemeines.pdf"
            },
            {
              title: "Pressemitteilung 4 - Programm",
              src: "/static/dokumente/pressemitteilung_4_programm.pdf"
            },
            {
              title: "Pressemitteilung 5 - Vorträge",
              src: "/static/dokumente/pressemitteilung_5_vortraege.pdf"
            },
            {
              title: "Pressemitteilung 6 - Parklet",
              src: "/static/dokumente/pressemitteilung_6_parklet.pdf"
            },
            {
              title: "Ergebnis der Umfrage",
              src: "/static/dokumente/umfrage_ergebnis.pdf"
            },
            {
              title: "Flyer Bürgerworkshop",
              src: "/static/dokumente/flyer_bürgerworkshop.pdf"
            },
            {
              title: "Dokumentation Arbeitsgruppe",
              src: "/static/dokumente/doku_arbeitsgruppe.pdf"
            },
            {
              title: "Dokumentation Online Umfrage",
              src: "/static/dokumente/doku_umfrage.pdf"
            },
            {
              title: "Dokumentation Bürgerwerkstatt",
              src: "/static/dokumente/doku_buergerwerkstatt.pdf"
            }
          ]
        },
        {
          title: "12/19",
          links: [
            {
              title: "Räumliches Leitbild",
              src: "/static/dokumente/raeumliches_leitbild.pdf"
            },
            {
              title: "Pressemitteilung 7 - Räumliches Leitbild",
              src:
                "/static/dokumente/pressemitteilung_7_raeumliches_leitbild.pdf"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
li {
  margin: 15px 10px;
  /* display: flex; */
  /* align-items: center; */
}
</style>